import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;

  .project-edit-btn {
    border: 1px solid #D0D5DD !important;
    border-radius: 8px !important;
    color: #384250 !important;

    &.primary {
      padding-top: 9px !important;
      color: white !important;
      border-width: 0px !important;
    }
  }

  .empty-state-repeatable {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    border-bottom: 1px solid var(--base-gray-30);
    margin-top: -1px;
  }

  .repeatable-header {
    .label {
      font-weight: 600 !important;
      font-size: 14px !important;
      color: var(--base-gray-90) !important;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: unset !important;
      max-width: 100%;
    }

    .input {
      background: var(--base-gray-30);

      &:first-of-type {
        border-top-left-radius: 8px;
      }

      &.last-input {
        border-top-right-radius: 8px;
      }

      span {
        font-weight: 600;
        font-size: 14px;
        color: var(--base-gray-90);
      }
    }
  }

  .ant-tabs-tabpane::-webkit-scrollbar {
    display: none !important;
  }
  .ant-page-header {
    box-shadow: 0px 4px 10px 0px #0000001F;
    z-index: 5;
    .ant-page-header-heading-left {
      overflow: initial;
    }
    .ant-page-header-back-button {
      margin-bottom: 2px;
      span[role="img"] {
        color: var(--mmt-primary-70);
      }
    }
    .ant-page-header-heading-extra {
      width: -webkit-fill-available;

      .ant-space {
        width: 100%;
        .ant-space-item {
          width: 100%;
        }
      }

      .actions {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-right: 12px;
        button {
          margin-right: var(--margin-xs);
          span[role="img"] {
            font-size: 14px;
            margin-top: 4px;
          }
        }
        button:last-of-type {
          color: #ffff;
          border: 0px;
          margin-right: 0;
        }
      }
    }
    .tag {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      p {
        margin: 0 8px 0 0;
      }
    }
  }
  .view-loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255,     255, 0.1);
    color: var(--mmt-primary-70);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 38px;
  }
  .ant-menu-vertical .ant-menu-item::after,
  .ant-menu-vertical-left .ant-menu-item::after,
  .ant-menu-vertical-right .ant-menu-item::after,
  .ant-menu-inline .ant-menu-item::after {
    border-right: 4px solid;
  }
  .ant-menu {
    min-width: 200px;
    height: 100%;
    box-shadow: 4px 0px 10px 0px #0000000F;
    .ant-menu-item {
      &:first-of-type {
        margin-top: 12px;
      }
      padding-left: var(--size)!important;
    }
    .ant-menu-submenu {
      .ant-menu-submenu-title {
        padding-left: var(--size) !important;
      }
      .ant-menu.ant-menu-sub {
        .ant-menu-item {
          padding-left: 32px !important;
        }
      }
    }
  }
  .view-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    width: 100%;
    flex: 1;
    overflow-y: auto;

    .content {
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      background: #f2f2f2;
      padding: 0 var(--size-lg);

      .content-card {
        max-width: 872px;
        width: 100%;
        border-radius: 8px;
        background: white;
        margin: var(--size-lg) auto;
        padding: 0 var(--size-lg) var(--size-lg) var(--size-lg);
      }

      .title {
        margin: 22px;
        font-size: var(--size-lg);
        border-bottom: 2px solid #E9E9E9;
        width: 100%;
        margin-bottom: 0;
        padding-bottom: 22px;
      }

      .wrapper {
        padding: 0;
        display: flex;
        gap: 44px;
        flex-direction: row;
        flex-wrap: wrap;
        background: white;
        border-radius: 4px;

        .group {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          position: relative;
          
          .title {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            color: var(--base-gray-70);
            margin: 0;
            border: none;
            padding: 0;

            &.title-with-tag {
              margin-right: 140px;
            }
            h1 {
              font-size: 14px;
              font-weight: 500;
              color: var(--base-gray-70);
              margin: 0;
            }
          }
          .input {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc(100% / 4);

            &.border-bottom-input {
              border-bottom: 2px solid var(--base-gray-30);
            }

            margin-bottom: var(--size);
            margin-top: auto !important;
            border: none;
            .label {
              display: flex;
              align-items: center;
            }
            .label, .value {
              line-height: 20px;
              margin: 0;
              color: var(--base-gray-70);
              font-weight: 500;
              font-size: 14px;
            }
            .value {
              font-weight: 500;
              color: var(--base-gray-90);
              font-size: 14px;
              margin-bottom: 0;
              margin-top: 8px;
            }
          }
          .input.checkboxGroup {
            margin-top: 12px !important;
            .opt {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 6px 0;
              color: rgba(0, 0, 0, 0.78);
              &:not(:last-of-type) {
                border-bottom: 1px solid rgba(0, 0, 0, 0.07);
              }
            }
          }
          .input.last {
            margin-bottom: 0px;
            // border: none;
            // &:not(:last-of-type) {
            //   margin-bottom: 8px;
            // }
            // .value {
            //   margin: 0;
            //   margin-top: 8px;
            // }
          }
          .input:last-child {
            margin-bottom: 0px;
            // border: none;
            // &:not(:last-of-type) {
            //   margin-bottom: 8px;
            // }
            // .value {
            //   margin: 0;
            //   margin-top: 8px;
            // }
          }
        }
        // .group .input:nth-last-child(-n + 2) {
        //   margin: 0;
        //   border: none;
        //   .value {
        //     margin: 0;
        //     margin-top: 8px;
        //   }
        // }
        .group.repeatable {
          justify-content: flex-start;
          border-bottom: 1px solid var(--base-gray-30);
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          overflow: hidden;

          .repeatable-row {
            width: 100%;
            display: flex;
            background-color: white;

            &.last {
              .value {
                border-bottom: 0px !important;
              }
            }

            button {
              border-radius: 8px;
              span[role="img"] {
                font-size: 12px;
                svg {
                  margin-top: -5px;
                }
              }
            }
            .input .value {
              font-size: 14px;
              color: var(--base-gray-90);
              padding-left: 12px;
              padding-right: 12px;
              text-wrap: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;

              p {
                font-size: 14px;
                text-wrap: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 100%;
              }
            }
            border-left: 1px solid var(--base-gray-30);
            border-right: 1px solid var(--base-gray-30);
            &.open {
              color: var(--mmt-primary-70) !important;
              background: #e6f7ff !important;
              border-left: 4px solid var(--mmt-primary-70) !important;

              .input {
                color: var(--mmt-primary-70) !important;
                background: #e6f7ff !important;
                border: 0px;
                .value {
                  color: var(--mmt-primary-70) !important;
                  background: #e6f7ff !important;
                  border: none;

                }
              }
            }
          }

          .input {
            margin-right: 0 !important;
            margin: 0;
            border-bottom: none;
            padding-left: 0;

            .label {
              display: flex;
              align-items: center;
              padding: 0px 8px 12px ;
              border-bottom: 1px solid var(--base-gray-30);
              min-height: 35px;
            }
            .value {
              padding: 8px 8px;
              border-bottom: 1px solid var(--base-gray-30);
              // height: 100%;
              margin-bottom: 0;
              margin-top: 0;
              max-height: 36px;
            }
            &.first-col{
              .value {
                padding-left: 14px;
                text-align: center;
              }
            }
          }

          .input.action {
            .value {
              text-align: center;
            }
          }
          .no-data {
            padding: 12px;
            background: white;
            width: 100%;
            text-align: center;
            margin-bottom: 0 !important;
          }
        }
        .group.repeatable {
          .title {
            margin-bottom: 0px;
            padding-bottom: 8px;
            color: var(--base-gray-70);
          }

          .input {

            &.last-input {
              margin-top: 0px !important;
            }
            .label {
              display: flex;
              align-items: center;
              height: 100%;
              padding: 8px 12px;
            }
          }
          .repetable-row-extra {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: var(--size) 0;
            background: #fbfbfb;
            // justify-content: center;
            // border-bottom: 1px solid #e4e8ed !important;
            overflow: hidden;
            transition: all 300ms ease, border-color 0s;

            .input {
              display: flex !important;
              flex-direction: column;
              justify-content: space-between;
              border-left: none;
              border-right: none;
            }
            .label, .value {
              font-size: 14px;
              line-height: 22px;
              margin: 0;
              border-bottom: none;
              padding-right: var(--size);
              padding-bottom: 0px;
              border-left: none;
              border-right: none;
            }
            .value {
              color: var(--base-gray-70);
              font-weight: 400;
              background: none;
              border-bottom: none;
              padding: 0 12px;
              margin-bottom: 12px;
              min-height: unset;
              font-size: 14px;

              .text-muted {
                margin-bottom: 0px;
              }
            }
            .input.last {
              // margin: 0;
              // border: none;
              // .value {
              //   margin: 0;
              // }
            }
            .input:last-child {
              // margin: 0;
              // border: none;
              // .value {
              //   margin: 0;
              // }
            }
          }
        }
        // .group.repeatable .input:nth-last-child(-n + 4) {
        //   margin: 0;
        //   border: none;
        //   .value {
        //     margin: 0;
        //     margin-top: 8px;
        //   }
        // }
      }
      .group.display {
        flex-wrap: wrap;
        .title {
          margin-bottom: 0;
        }
        .group {
          width: calc(100% / 2 - 8px);
          background: white;
          margin-bottom: 0;
          margin-top: var(--size);
          .title {
            margin-bottom: var(--size);
            h1 {
              font-size: var(--font-size-lg);
            }
          }
        }
      }

      &.documents-layout, &.project-layout {
        .wrapper {
          .view-header{ 
            padding: var(--size-lg);
            margin-bottom: -16px;
            border-bottom: 1px solid var(--base-gray-30);
            width: 100%;
            padding: var(--size-lg) 0;

            h1 {
              font-size: 18px;
              margin-bottom: 0px;
              font-weight: 500;
            }
          }

          .group {
            border-bottom: 0px;
            padding-bottom: 0px;

            .title {
              padding-bottom: 20px;
            }

            .input {
              padding-left: 0px;
            }
          }
        }
      }

      &.project-sources-layout {
        height: calc(100% - 3px);
        overflow-y: auto;
        display: unset;
      }
    }

    .section-tabs {
      .ant-tabs-bar.ant-tabs-top-bar {
        display: flex;
        justify-content: center;
        border-bottom: none;
      }
    }
  }
  .anticon {
    vertical-align: 0;
    margin-right: 5px;
  }

  .download-btn .anticon {
    margin-top: 3px;
    margin-right: 0px;
  }

  .risk-template{
    .risk-disabled{
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
    }
    .risk-disabled-intro{
      font-style: italic;
      font-weight: normal;
      font-size: 12px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: #4F4F4F;
      .round-icon {
        background: rgba(130, 130, 130, 0.05);
        width: var(--size-lg);
        height: var(--size-lg);
        border-radius: 50%;
        display: flex;
        justify-content: center;
      }
    }
    .risk-title {
      font-style: normal;
      font-weight: bold;
      font-size: var(--font-size-lg);
      line-height: 22px;
      display: flex;
      align-items: center;
      color: #001529;

      .anticon {
        font-size: 20px;
        color: #BDBDBD;
      }
    }
    .risk-score-main-graph{
      height: 105px;
      border: 1px solid #F5F5F5;
      box-sizing: border-box;
      padding: var(--size-lg);
    }
    .ant-tabs-nav-scroll {
      margin-bottom: 12px;
    }
    .ant-tabs-tab {
      padding: 8px 12px;
      margin-right: var(--size);
    }
    .ant-tabs-tab-active {
      background: rgba(24, 144, 255, 0.1);
      padding: 8px 12px;
      border-radius: 5px;
    }
    .ant-tabs-nav.ant-tabs-nav-animated {
      overflow: hidden;
    }
    .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
      display: none !important;
    }
    .ant-breadcrumb {
      margin-bottom: var(--size);
    }
    .riskLevel {
      svg {
        margin-right: 8px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        padding: 6px;
      }
    }
    .riskComponents {
      display: flex;
      .component {
        p {
          margin-bottom: 0
        }
        width: 120px;
        display: flex;
        flex-direction: column;
        margin-right: 22px;
      }
    }
    .formPreview, .riskEvolution {
      border: 1px solid #F5F5F5;
      box-sizing: border-box;
      box-shadow: 0px 4px 4px rgba(166, 173, 180, 0.1);
      border-radius: 2px;
      width: 100%;
      margin-bottom: 20px;
      .head {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        padding: var(--size) var(--size) 0 var(--size);
        div {
          display: inherit;
          align-items: inherit;
        }
        h1 {
          margin: 0;
          font-size: var(--font-size-lg);
          margin-left: 8px;
        }
        button {
          span[role="img"] {
            margin: 0;
          }
        }
      }
      .content {
        padding-top: 0;
      }
      .content::-webkit-scrollbar {
        display: none;
      }
      .ant-divider {
        margin: 0 0 20px 0;
        padding: 0 20px;
        cursor: pointer;
      }
    }
    .riskEvolution {
      .head {
        padding-bottom: var(--size);
      }
      .evolution {
        padding: 14px;
        margin: 0 var(--size);
        border: 1px dashed #D7DAEA;
        box-sizing: border-box;
        border-radius: 3px;
        margin-bottom: 32px;
        position: relative;
        height: 63px;
        // overflow: hidden;
        .head {
          padding: 0;
          margin-bottom: var(--size);
          .score {
            padding: 5px;
            min-width: 40px;
            min-height:  40px;
            max-width: 40px;
            max-height:  40px;
            border-radius: 50%;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #BFBFBF;
            box-sizing: border-box;
            color: #BFBFBF;
          }
          h1 {
            font-size: var(--font-size-lg);
            margin: 0;
            font-weight: 400;
            margin-left: 8px;
          }
          button {
            color: var(--mmt-primary-70);
            border-color: var(--mmt-primary-70);
            border-radius: 5px;
          }
        }
        &:nth-of-type(1) {
          margin-top: var(--size);
        }
        &:not(:last-of-type) {
          &:after {
            content: '';
            width: 1px;
            height: 18px;
            position: absolute;
            bottom: -25px;
            left: 25px;
            background: #E8E8E8;
            z-index: 2;
          }
        }
      }
      .evolution.current {
        border-color: var(--mmt-primary-70);
        height: auto;
        .head {
          .score {
            background: var(--mmt-primary-70);
            color: white;
            border-color: var(--mmt-primary-70);
          }
          h1 {
            font-weight: 600;
          }
        }
      }
    }
    .riskProfile {
      width: calc(100% / 3 - 8px);
      box-shadow: 0px 4px 4px rgba(166, 173, 180, 0.1);
      border-radius: 2px;
      border: 1px solid #F5F5F5;
      height: auto;
      padding: var(--size);
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          display: flex;
          align-items: center;
        }
        h1 {
          font-size: 18px;
          color: #001529;
          margin: 0 0 0 8px;
        }
      }
      .subScores {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .subScore {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex-grow: 1;
          min-width: 100px;
          flex-wrap: wrap;
          p {
            margin: 0;
            margin-bottom: 4px;
          }
          .levels {
            display: flex;
            justify-content: space-between;
            height: 15px;
            div {
              width: 15px;
              margin-right: 3px;
              height: 100%;
              background: #f3f3f3;
              &:last-of-type{
                margin-right: 0;
              }
            }
          }
        }
      }
      .riskScore {
        font-size: 14px;
        text-align: center;
        margin: 0;
        color: #001529;
        font-weight: 400;
      }
      .subRiskScore {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 26px;
        .subContainer1, .subContainer2, .subContainer3 {
          width: calc(100% / 3 - 8px);
        }
        p {
          width: calc(100% / 3 - 8px);
          text-align: center;
          font-weight: 600;
          color: #001529;
          text-transform: capitalize;
        }
      }
      .timeline {
        display: flex;
        justify-content: space-between;
        align-items: space-between;
        height: 260px;
        .weekDay {
          width: var(--size);
          text-align: center;
          height: 230px;
          font-size: 10px;
          .dayCol {
            height: 100%;
            width: 100%;
            margin-bottom: 8px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .event {
              width: 100%;
              background: red;
              height: 35px;
              border-radius: 2px;
              z-index: 1;
              margin-top: 2px;
              cursor: pointer;
              opacity: 0.8;
              transition: opacity 0.3s ease-in-out;
              &:hover{
                opacity: 1;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
              }
            }
            &::after {
              content: '';
              position: absolute;
              width: 1px;
              height: 100%;
              background: #F2F2F2;
              top: 0;
              left: 0;
              right: 0;
              margin: auto;
            }
          }
        }
      }
      .risk-trend-content{
        flex: 1 1 auto;
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
  .ant-tabs-tab span i {
    font-size: 18px;
    line-height: var(--size);
    top: 3px;
    position: relative;
    margin-right: 10px;
  }
  .image-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    vertical-align: middle;
    .ant-image{
      border: 1px solid rgb(204, 204, 204);
      margin-right: 10px;
    }
  }
  @media (min-width: 768px){
    .group.col-md-6.col-sm-12.ml-2,
    .group.col-md-6.col-sm-12.mr-2 {
      flex: 0 0 calc(50% - 0.75rem);
      max-width: calc(50% - 0.75rem);
    }
  }
  b{
    color: #001529;
  }
  .event-popover{
    width: 250px;
    .list-item {
      justify-content: space-evenly;
      label {
        width: 65px;
      }
      div {
        width: calc(100% - 65px);
      }
    }
  }
  .risk-profile-container{
    div{
      margin: auto;
    }
  }
  .preview-modal {
    .ant-modal-body {
      padding: 0;
    }
  }
  .ant-image-preview-root{
    .ant-image-preview-operations {
      background: #002A52;
      height: 70px;
    }
  }
  .website-link {
    color: #096DD9;
    text-decoration-line: underline;
  }
`;
